Deletes an unposted position profile.
